module.exports = __webpack_public_path__ + "static/img/exit.1d10932.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/exit.png
// module id = ILV/
// module chunks = 1